import * as R from 'remeda';
import { Chip, Stack, Typography } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { text } from '../../../constants';
import { GridRowModel } from '../../rows/rowTypes';

type ChipsCellProps = GridRenderCellParams<
  GridRowModel,
  Array<string> | string
>;

export const ChipsCell = ({ value }: ChipsCellProps) => {
  if (R.isArray(value) && value?.length) {
    return (
      <Stack spacing={1} direction="row" height={1} alignItems="center">
        {value?.map(chipLabel => (
          // CHECK Changed from tiny
          <Chip key={chipLabel} label={chipLabel} />
        ))}
      </Stack>
    );
  }

  return value === text.cellNotEditable ? (
    <Stack height={1} justifyContent="center">
      <Typography
        variant="body2"
        sx={{ color: 'text.disabled', cursor: 'not-allowed' }}
      >
        {value}
      </Typography>
    </Stack>
  ) : null;
};

export const renderChipsCell = (params: ChipsCellProps) => (
  <ChipsCell {...params} />
);
